import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import EditFormControl from 'ContentComponents/cmv2/EditFormControl';
import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import Small from 'UIComponents/elements/Small';
import shallowCompare from 'react-addons-shallow-compare';
import FileDropZone from 'ContentComponents/cmv2/FileDropZone';
import Routes from 'ContentUtils/Routes';
import { IMAGE_GENERATION_ENABLED_APPS, TypeToExtensions } from 'FileManagerCore/Constants';
import { FileExtensionFilterTypes, FileTypes, PickerPanels } from 'file-manager-components/constants';
import { hasScope } from 'ContentUtils/helpers/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.file.${key}`;
const buttonI18nKey = key => `ContentComponents.buttons.${key}`;
const IMAGE_GENERATION_GATE = 'CMS:GenerativeAIImages';
class FileBase extends Component {
  constructor(props) {
    super(props);
    this.onClickGenerate = () => {
      const {
        onFileManagerOpen,
        handleFileSelect
      } = this.props;
      onFileManagerOpen(handleFileSelect, {
        initialPanel: PickerPanels.IMAGE_GENERATION
      });
      this.trackEvent('click-generate-image');
    };
    this.onFileManagerOpen = this.onFileManagerOpen.bind(this);
    this.onFileDrop = this.onFileDrop.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  get fieldKey() {
    const {
      fieldKey
    } = this.props;
    return fieldKey && fieldKey.join('.');
  }
  shouldShowGenerateButton() {
    const hasImageGenerationAccessScope = hasScope('image-generation-access');
    const {
      fileType
    } = this.props;
    return fileType === FileTypes.IMG && Routes.isUngated(IMAGE_GENERATION_GATE) && hasImageGenerationAccessScope && IMAGE_GENERATION_ENABLED_APPS.includes(Routes.getCurrentApp());
  }
  trackEvent(eventKey) {
    const {
      trackFieldAction
    } = this.props;
    if (trackFieldAction) {
      trackFieldAction(eventKey);
    }
  }
  onFileManagerOpen() {
    const {
      fileType,
      onFileManagerOpen,
      handleFileSelect
    } = this.props;
    onFileManagerOpen(handleFileSelect);
    this.trackEvent(`click-browse-${(fileType || 'file').toLowerCase()}`);
  }
  onFileDrop(url, response) {
    const {
      fileType,
      handleFileSelect
    } = this.props;
    if (!url) {
      return;
    }
    if (response) {
      handleFileSelect(response);
    }
    this.trackEvent(`upload-${(fileType || 'file').toLowerCase()}`);
  }
  renderContent() {
    const {
      browseText,
      contentAssistanceEnabled,
      children,
      fileName,
      fileType,
      filteredExtensions,
      hasValue,
      readOnly,
      removeOnly,
      uploadedFileAccess,
      uploadText,
      useOnDark,
      value
    } = this.props;
    if (children) {
      return children;
    }
    if (!hasValue) {
      const typeExtensionKey = fileType;
      const extensions = TypeToExtensions.get(FileTypes[typeExtensionKey]);
      const allExtensions = extensions ? extensions.toJS() : [];
      return /*#__PURE__*/_jsx(FileDropZone, {
        browseText: browseText || unescapedText(i18nKey('browseFiles')),
        contentAssistanceEnabled: contentAssistanceEnabled,
        readOnly: readOnly || removeOnly,
        fieldKey: this.fieldKey,
        filteredExtensions: filteredExtensions || allExtensions,
        filterType: fileType ? FileExtensionFilterTypes.SUPPORTED : FileExtensionFilterTypes.NONE,
        onChange: this.onFileDrop,
        onClick: this.onFileManagerOpen,
        onClickGenerate: this.onClickGenerate,
        showGenerate: this.shouldShowGenerateButton(),
        uploadedFileAccess: uploadedFileAccess,
        uploadText: uploadText || unescapedText(i18nKey('uploadFile'))
      });
    }
    return /*#__PURE__*/_jsx(UIFileAttachment, {
      "data-selenium": "file-attachment",
      "data-value": value,
      fileName: value || fileName,
      size: "small",
      use: useOnDark ? 'on-dark' : 'default'
    });
  }
  renderReplaceAndRemoveButtons() {
    const {
      removeOnly,
      readOnly,
      onClearFile,
      required
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "cmv2-file-replace",
        disabled: readOnly || removeOnly,
        onClick: this.onFileManagerOpen,
        use: "link",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonI18nKey('replace')
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "cmv2-file-remove",
        disabled: readOnly || required && !removeOnly,
        onClick: onClearFile,
        use: "link",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonI18nKey('remove')
          })
        })
      })]
    });
  }
  render() {
    const {
      hasValue,
      helpText,
      inlineHelpText,
      label,
      required
    } = this.props;
    return /*#__PURE__*/_jsx(EditFormControl, {
      label: label,
      required: required,
      helpText: helpText,
      inlineHelpText: inlineHelpText,
      labelItemRight: hasValue && this.renderReplaceAndRemoveButtons(),
      children: this.renderContent()
    });
  }
}
FileBase.defaultProps = {
  readOnly: false,
  removeOnly: false,
  required: false,
  value: null
};
export default FileBase;